<template>
  <div class="header">
    <el-menu :default-active="1" class="el-menu-demo" mode="horizontal">
    <el-menu-item index="1">处理中心</el-menu-item>
    <el-menu-item index="2">处理中心</el-menu-item>
    <el-menu-item index="3">消息中心</el-menu-item>
    <el-menu-item index="4">消息中心</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
  export default {
    	data(){
    		return {
    		}
    	}
    }
</script>

<style lang="less">
</style>
